import React, { PureComponent } from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import {
  Checkbox,
  DatePicker,
  Icon,
  Input,
  Modal,
  Radio,
  Select,
  Table,
  Tooltip
} from 'antd';
import './VideoManage.less';
import { Btn, OperateSpan } from '../../components/Widgets';
import moment from 'moment';
import { Player } from 'video-react';
import UserSelect from '../../components/meeting/UserSelect';
import { VIDEO_PUBLIC_MODAL } from '../../utils/constants';
import IconTip from '../../components/IconTip';
import _ from 'lodash';

class VideoManage extends PureComponent {
  constructor() {
    super();
    this.state = {
      showEditModal: false,
      showLivingModal: false,
      showRecordingModal: false,
      showUserSelect: false,
      editObj: {},
      livingEditObj: {},
      recordingEditObj: {},
      selectedVideo: [],
      currentVideoUrl: '',
      videoList: [],
      userList: [],
      orginalObj: {}
    };
  }

  onSubmit = () => {
    const { editObj } = this.state;
    const { dispatch, meetingVideos } = this.props;
    const { pageNo, pageSize } = meetingVideos;

    //校验一下数据

    const { mainTains } = editObj;

    let msg = '';
    for (let mt of mainTains) {
      if (mt.time === '') {
        msg = '维护时间不能为空';
        break;
      }
      if (mt.user === '') {
        msg = '维护人不能为空';
        break;
      }
      if (mt.remark === '') {
        msg = '维护记录不能为空';
        break;
      }
    }
    if (msg != '') {
      Modal.warning({ content: msg });
      return;
    }
    const promise = new Promise((resolve, reject) => {
      dispatch({
        type: 'account/updateMeetingVideoApply',
        resolve,
        reject,
        meetingVideo: editObj
      });
    });
    promise.then(
      () => {
        Modal.success({ content: '操作成功!' });
        this.setState({ showEditModal: false });
        dispatch({
          type: 'account/getAllMeetingVideo',
          payload: { current: pageNo, pageSize: pageSize }
        });
      },
      msg => {
        Modal.error({ content: msg });
      }
    );
  };

  showEditModal = record => {
    this.setState({
      showEditModal: true,
      editObj: { ...{}, ...record },
      orginalObj: _.cloneDeep(record)
    });
  };

  showLivingModal = record => {
    let userList = record.livingUsers;
    userList.map(item => {
      item.selectType = item.userType;
    });
    this.setState({
      showLivingModal: true,
      livingEditObj: { ...{}, ...record },
      userList
    });
  };

  showRecordingModal = record => {
    const { dispatch } = this.props;
    const this_ = this;
    //清掉旧的信息
    let userList = record.recordingUsers;
    userList.map(item => {
      item.selectType = item.userType;
    });
    if (userList.length == 0) {
    }
    let selectedVideo = [];
    if (record.recordVideos) {
      let videos = JSON.parse(record.recordVideos);
      selectedVideo = videos;
    }
    this.setState({ currentVideoUrl: '', userList, selectedVideo });
    const promise = new Promise((resolve, reject) => {
      dispatch({
        type: 'account/getVideosByMeetingId',
        resolve,
        reject,
        meetingId: record.meetingId
      });
    });
    promise.then(
      videos => {
        this_.setState({
          showRecordingModal: true,
          recordingEditObj: { ...{}, ...record },
          videoList: videos
        });
      },
      msg => {
        console.log('获取会议录播视频失败', msg);
        this_.setState({
          showRecordingModal: true,
          recordingEditObj: { ...{}, ...record },
          videoList: []
        });
      }
    );
  };

  createEditModal = () => {
    const { editObj, showEditModal } = this.state;
    return (
      <Modal
        wrapClassName="video-manage-wrapper meeting-video-update modal-close-header"
        maskClosable={false}
        visible={showEditModal}
        title={'修改申请'}
        width={700}
        onCancel={() => {
          this.setState({ showEditModal: false });
        }}
        onOk={() => {
          this.onSubmit();
        }}
        footer={
          <div className="service-manage-footer">
            <Btn onClick={() => this.setState({ showEditModal: false })}>
              {`取消`}
            </Btn>
            <Btn primary onClick={() => this.onSubmit()}>
              {`确定`}
            </Btn>
          </div>
        }
      >
        <div className="service-manage-modal device_manage  video_manage">
          <div className="manage-row">
            <span className="prefix-title">
              <i className="required-flag">*</i>
              类型 :
            </span>
            <Checkbox.Group
              disabled={true}
              options={[
                { label: '直播', value: '1' },
                { label: '录播', value: '2' }
              ]}
              value={
                this.state.editObj.applyType
                  ? this.state.editObj.applyType.split(',')
                  : []
              }
            />
          </div>
          <div className="manage-row">
            <span className="prefix-title">
              <i className="required-flag">*</i>
              对接联系人姓名 :
            </span>
            <span>{editObj.contactUser || ''}</span>
            <span className="prefix-title" style={{ marginLeft: '30px' }}>
              <i className="required-flag">*</i>
              对接联系人电话 :
            </span>
            <span>{editObj.contactMobile || ''}</span>
          </div>
          <div className="manage-row">
            <span className="prefix-title">直录播要求 : </span>
            <span>{editObj.requirement || ''}</span>
          </div>
          <div className="manage-row">
            <span className="prefix-title">附件 : </span>
            <div
              style={{ overflow: 'auto' }}
              onClick={() => {
                window.open(editObj.filePath);
              }}
            >
              {editObj.filePath || editObj.fileName ? (
                <a style={{ color: '#4680FF' }}>
                  <Icon type="link" />
                  &nbsp;&nbsp;
                  {editObj.fileName
                    ? editObj.fileName
                    : editObj.filePath
                      ? editObj.filePath
                      : ''}
                </a>
              ) : null}
            </div>
          </div>
          <div className="manage-row">
            <span className="prefix-title">申请状态 : </span>
            <Radio.Group
              onChange={e => {
                this.setState({
                  editObj: {
                    ...this.state.editObj,
                    ...{
                      state: e.target.value
                    }
                  }
                });
              }}
              value={this.state.editObj.state + ''}
              options={[
                { label: '新申请', value: '0', disabled: true },
                {
                  label: '处理中',
                  value: '1',
                  disabled: this.state.orginalObj.state == 2
                },
                { label: '已完成', value: '2' }
              ]}
            />
          </div>
          <div className="manage-row record-row">
            <span className="prefix-title">维护记录 : </span>
            <div>
              {editObj.mainTains &&
                editObj.mainTains.map(item => {
                  return (
                    <div style={{ display: 'flex', marginBottom: '15px' }}>
                      <div
                        style={{
                          height: '30px',
                          width: '150px',
                          border: 'none',
                          marginRight: '20px'
                        }}
                      >
                        <Input
                          placeholder="维护时间"
                          onChange={e => {
                            const newState = Object.assign({}, this.state);
                            newState.editObj.mainTains &&
                              newState.editObj.mainTains.map(mt => {
                                if (mt.id == item.id) {
                                  mt.time = e.target.value;
                                }
                              });
                            this.setState(newState);
                          }}
                          defaultValue={item.time}
                        />
                      </div>
                      <div
                        style={{
                          height: '30px',
                          width: '150px',
                          border: 'none',
                          marginRight: '20px'
                        }}
                      >
                        <Input
                          placeholder="维护人"
                          onChange={e => {
                            const newState = Object.assign({}, this.state);
                            newState.editObj.mainTains &&
                              newState.editObj.mainTains.map(mt => {
                                if (mt.id == item.id) {
                                  mt.user = e.target.value;
                                }
                              });
                            this.setState(newState);
                          }}
                          defaultValue={item.user}
                        />
                      </div>
                      <div
                        style={{
                          height: '30px',
                          width: '150px',
                          border: 'none'
                        }}
                      >
                        <Input
                          placeholder="维护记录"
                          maxLength="50"
                          onChange={e => {
                            const newState = Object.assign({}, this.state);
                            newState.editObj.mainTains &&
                              newState.editObj.mainTains.map(mt => {
                                if (mt.id == item.id) {
                                  mt.remark = e.target.value;
                                }
                              });
                            this.setState(newState);
                          }}
                          defaultValue={item.remark}
                        />
                      </div>

                      <span
                        style={{ marginLeft: '10px' }}
                        onClick={() => {
                          this.setState({
                            editObj: {
                              ...this.state.editObj,
                              ...{
                                mainTains: this.state.editObj.mainTains.filter(
                                  mt => mt.id != item.id
                                )
                              }
                            }
                          });
                        }}
                      >
                        <IconTip title="删除" type="shanchu" />
                      </span>
                    </div>
                  );
                })}
              <div
                style={{
                  height: '30px',
                  width: '490px',
                  border: '1px dashed #d9d9d9',
                  textAlign: 'center',
                  lineHeight: '30px'
                }}
                onClick={() => {
                  this.setState({
                    editObj: {
                      ...this.state.editObj,
                      ...{
                        mainTains: this.state.editObj.mainTains.concat([
                          {
                            id: 'temp' + Math.random(),
                            user: '',
                            time: '',
                            remark: ''
                          }
                        ])
                      }
                    }
                  });
                }}
              >
                + 新增维护记录
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  };

  cancelLivingVideo = record => {
    const { dispatch, meetingVideos } = this.props;
    const { pageNo, pageSize } = meetingVideos;
    const { meetingId } = record;

    const promise = new Promise((resolve, reject) => {
      dispatch({
        type: 'account/publicLiveVideo',
        resolve,
        reject,
        params: { action: 0, meetingId: meetingId }
      });
    });
    promise.then(
      () => {
        Modal.success({ content: '取消直播成功' });
        dispatch({
          type: 'account/getAllMeetingVideo',
          payload: { current: pageNo, pageSize: pageSize }
        });
      },
      msg => {
        Modal.error({ content: msg });
      }
    );
  };

  cancelRecordVideo = record => {
    const { dispatch, meetingVideos } = this.props;
    const { pageNo, pageSize } = meetingVideos;
    const { meetingId } = record;

    const promise = new Promise((resolve, reject) => {
      dispatch({
        type: 'account/publicRecordVideo',
        resolve,
        reject,
        params: { meetingId, action: 0 }
      });
    });
    promise.then(
      () => {
        Modal.success({ content: '取消发布录播成功' });
        this.setState({ showRecordingModal: false });
        dispatch({
          type: 'account/getAllMeetingVideo',
          payload: { current: pageNo, pageSize: pageSize }
        });
      },
      msg => {
        Modal.error({ content: msg });
      }
    );
  };

  publicLivingVideo = () => {
    const { livingEditObj } = this.state;
    const { dispatch, meetingVideos } = this.props;
    const { pageNo, pageSize } = meetingVideos;
    if (!livingEditObj.liveUrl) {
      Modal.warning({ content: '直播地址不能为空!' });
      return;
    }
    if (!livingEditObj.liveStartTime) {
      Modal.warning({ content: '直播开始时间不能为空!' });
      return;
    }
    if (!livingEditObj.liveEndTime) {
      Modal.warning({ content: '直播结束时间不能为空!' });
      return;
    }

    if (typeof livingEditObj.liveStartTime == 'number') {
      livingEditObj.liveStartTime = moment(
        new Date(livingEditObj.liveStartTime)
      ).format('YYYY-MM-DD HH:mm:ss');
    }

    if (typeof livingEditObj.liveEndTime == 'number') {
      livingEditObj.liveEndTime = moment(
        new Date(livingEditObj.liveEndTime)
      ).format('YYYY-MM-DD HH:mm:ss');
    }

    const nowStr = moment().format('YYYY-MM-DD HH:mm:ss');

    if (livingEditObj.liveStartTime < nowStr) {
      Modal.warning({ content: '直播开始时间不能小于当前时间' });
      return;
    }

    if (livingEditObj.liveEndTime < nowStr) {
      Modal.warning({ content: '直播结束时间不能小于当前时间' });
      return;
    }

    if (livingEditObj.liveStartTime > livingEditObj.liveEndTime) {
      Modal.warning({ content: '直播结束时间不能早于开始时间!' });
      return;
    }
    if (!this.state.userList || this.state.userList.length == 0) {
      Modal.warning({ content: '发布范围需要至少选择一个用户!' });
      return;
    }
    let params = {
      ...{
        liveUrl: livingEditObj.liveUrl,
        liveStartTime: livingEditObj.liveStartTime,
        liveEndTime: livingEditObj.liveEndTime,
        userList: this.state.userList
      },
      ...{
        meetingId: livingEditObj.meetingId,
        livePubState: 1,
        action: 1
      }
    };
    const promise = new Promise((resolve, reject) => {
      dispatch({ type: 'account/publicLiveVideo', resolve, reject, params });
    });
    promise.then(
      () => {
        Modal.success({ content: '发布成功' });
        this.setState({ showLivingModal: false });
        dispatch({
          type: 'account/getAllMeetingVideo',
          payload: { current: pageNo, pageSize: pageSize }
        });
      },
      msg => {
        Modal.error({ content: msg });
      }
    );
  };

  publishRecordingVideo = () => {
    const { recordingEditObj, selectedVideo } = this.state;
    const { dispatch, meetingVideos } = this.props;
    const { pageNo, pageSize } = meetingVideos;

    if (!selectedVideo || selectedVideo.length == 0) {
      Modal.warning({ content: '请选择录播视频!' });
      return;
    }

    if (!this.state.userList || this.state.userList.length == 0) {
      Modal.warning({ content: '发布范围需要至少选择一个用户!' });
      return;
    }
    let params = {
      action: 1,
      meetingId: recordingEditObj.meetingId,
      selectedVideo,
      userList: this.state.userList
    };

    const promise = new Promise((resolve, reject) => {
      dispatch({ type: 'account/publicRecordVideo', resolve, reject, params });
    });
    promise.then(
      () => {
        Modal.success({ content: '发布成功' });
        this.setState({ showRecordingModal: false });
        dispatch({
          type: 'account/getAllMeetingVideo',
          payload: { current: pageNo, pageSize: pageSize }
        });
      },
      msg => {
        Modal.error({ content: msg });
      }
    );
  };

  createLivingModal = () => {
    const { livingEditObj, showLivingModal } = this.state;
    return (
      <Modal
        wrapClassName="video-manage-wrapper meeting-video-update modal-close-header"
        maskClosable={false}
        visible={showLivingModal}
        title={'直播发布'}
        width={700}
        onCancel={() => {
          this.setState({ showLivingModal: false });
        }}
        footer={
          <div className="service-manage-footer">
            <Btn onClick={() => this.setState({ showLivingModal: false })}>
              {`取消`}
            </Btn>
            <Btn primary onClick={() => this.publicLivingVideo()}>
              {`确定`}
            </Btn>
          </div>
        }
      >
        <div className="service-manage-modal device_manage">
          <div className="manage-row">
            <span className="prefix-title">
              <i className="required-flag">*</i>
              直播地址 :
            </span>
            <Input
              maxLength="120"
              placeholder="请输入直播URL"
              value={this.state.livingEditObj.liveUrl || ''}
              onChange={e => {
                this.setState({
                  livingEditObj: {
                    ...this.state.livingEditObj,
                    ...{ liveUrl: e.target.value }
                  }
                });
              }}
            />
          </div>
          <div className="manage-row">
            <span className="prefix-title">
              <i className="required-flag">*</i>
              直播时间 :
            </span>
            <DatePicker
              showTime
              format="YYYY-MM-DD HH:mm:ss"
              placeholder="开始时间"
              value={
                this.state.livingEditObj.liveStartTime
                  ? moment(this.state.livingEditObj.liveStartTime)
                  : null
              }
              onChange={(date, dateStr) => {
                this.setState({
                  livingEditObj: {
                    ...this.state.livingEditObj,
                    ...{ liveStartTime: dateStr }
                  }
                });
              }}
            />
            &nbsp;&nbsp;—&nbsp;&nbsp;
            <DatePicker
              showTime
              format="YYYY-MM-DD HH:mm:ss"
              placeholder="结束时间"
              value={
                this.state.livingEditObj.liveEndTime
                  ? moment(this.state.livingEditObj.liveEndTime)
                  : null
              }
              onChange={(date, dateStr) => {
                this.setState({
                  livingEditObj: {
                    ...this.state.livingEditObj,
                    ...{ liveEndTime: dateStr }
                  }
                });
              }}
            />
          </div>
          <div className="manage-row record-row" style={{ marginTop: '10px' }}>
            <span className="prefix-title">
              <i className="required-flag">*</i>
              发布范围 :{' '}
            </span>
            <div style={{ width: '100%' }}>
              <Btn
                onClick={() => {
                  this.setState({ showUserSelect: true });
                }}
              >
                {`+ 添加`}
              </Btn>
              <div style={{ height: '10px' }} />
              <div className="public-user-table">
                <Table
                  pagination={false}
                  rowKey={record => record.id}
                  dataSource={this.state.userList}
                  columns={[
                    {
                      title: '姓名',
                      key: 'name',
                      render: record => {
                        if (record.selectType == 0) {
                          return (
                            <span className="meeting-inner-attend">
                              {record.userName}
                            </span>
                          );
                        } else {
                          return (
                            <span className="meeting-outer-attend">
                              {record.userName}
                            </span>
                          );
                        }
                      }
                    },
                    {
                      title: '部门',
                      key: 'dept',
                      render: record => {
                        if (record.selectType == 0) {
                          return (
                            <span className="meeting-inner-attend">
                              {record.dept}
                            </span>
                          );
                        } else {
                          return (
                            <span className="meeting-outer-attend">
                              {record.dept}
                            </span>
                          );
                        }
                      }
                    },
                    {
                      title: '职位',
                      key: 'position',
                      render: record => {
                        if (record.selectType == 0) {
                          return (
                            <span className="meeting-inner-attend">
                              {record.position}
                            </span>
                          );
                        } else {
                          return (
                            <span className="meeting-outer-attend">
                              {record.position}
                            </span>
                          );
                        }
                      }
                    },
                    {
                      title: '操作',
                      key: 'operate',
                      render: record => {
                        return (
                          <span
                            style={{ paddingLeft: '15px' }}
                            onClick={() => {
                              let newUserList = this.state.userList.filter(
                                u => {
                                  return u.userId != record.userId;
                                }
                              );
                              this.setState({ userList: newUserList });
                            }}
                          >
                            <IconTip title="删除" type="shanchu" />
                          </span>
                        );
                      }
                    }
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  };

  createRecordingModal = () => {
    const { recordingEditObj, showRecordingModal } = this.state;
    let selectedRowKeys = [];
    this.state.selectedVideo.map(sv => {
      selectedRowKeys.push(sv.id);
    });
    return (
      <Modal
        wrapClassName="video-manage-wrapper video-manager-wrapper modal-close-header"
        maskClosable={false}
        visible={showRecordingModal}
        title={'录播发布'}
        onCancel={() => {
          this.setState({ showRecordingModal: false, currentVideoUrl: '' });
        }}
        footer={
          <div className="service-manage-footer">
            <Btn
              onClick={() =>
                this.setState({
                  showRecordingModal: false,
                  currentVideoUrl: ''
                })
              }
            >
              {`取消`}
            </Btn>
            <Btn primary onClick={() => this.publishRecordingVideo()}>
              {`确定`}
            </Btn>
          </div>
        }
      >
        <div className="service-manage-modal device_manage">
          <div className="manage-row recording-manage-row">
            <span className="prefix-title recording-prefix-title">
              视频列表 :
            </span>
            <div
              style={{
                width: '400px',
                maxHeight: '250px',
                overflow: 'auto',
                marginRight: '15px'
              }}
            >
              <div style={{ width: '100%', height: 'auto' }}>
                <Table
                  columns={[
                    {
                      title: '视频',
                      key: 'name',
                      render: record => {
                        let color = '';
                        return (
                          <span
                            style={{ color: '#1B86E3' }}
                            onClick={() => {
                              this.setState({ currentVideoUrl: record.url });
                            }}
                          >
                            <a>
                              <Icon
                                type="video-camera"
                                style={{ color: '#1B86E3' }}
                              />
                              &nbsp;&nbsp;
                              <span
                                style={
                                  record.url == this.state.currentVideoUrl
                                    ? { color: '#4680FF' }
                                    : {}
                                }
                              >
                                {record.name}
                              </span>
                            </a>
                          </span>
                        );
                      }
                    },
                    {
                      title: '选择',
                      key: 'isCheck',
                      render: record => {
                        return (
                          <Checkbox
                            checked={this.state.selectedVideo.some(
                              sv => sv.id == record.id
                            )}
                            onChange={e => {
                              let checked = e.target.checked;
                              let selectedVideo = this.state.selectedVideo;
                              let newSelectedVideo = [];
                              if (checked) {
                                if (
                                  !selectedVideo.some(sv => sv.id == record.id)
                                ) {
                                  newSelectedVideo = selectedVideo.concat(
                                    record
                                  );
                                }
                              } else {
                                newSelectedVideo = selectedVideo.filter(
                                  sv => sv.id != record.id
                                );
                              }
                              this.setState({
                                selectedVideo: newSelectedVideo
                              });
                            }}
                          />
                        );
                      }
                    }
                  ]}
                  dataSource={this.state.videoList || []}
                  rowKey={record => record.id}
                  pagination={false}
                />
              </div>
            </div>
            <div
              style={{
                width: '560px',
                height: '210px',
                backgroundColor: 'black'
              }}
              className="video_manage_player"
            >
              <Player
                playsInline
                fluid={false}
                width={'100%'}
                height={'100%'}
                autoPlay={true}
                src={this.state.currentVideoUrl}
              />
            </div>
          </div>

          <div className="manage-row record-row" style={{ marginTop: '10px' }}>
            <span className="prefix-title recording-prefix-title">
              发布范围 :{' '}
            </span>
            <div style={{ width: '100%' }}>
              <Btn
                onClick={() => {
                  this.setState({ showUserSelect: true });
                }}
              >
                {`+ 添加`}
              </Btn>
              <div style={{ height: '10px' }} />
              <div className="public-user-table">
                <Table
                  pagination={false}
                  rowKey={record => record.id}
                  dataSource={this.state.userList}
                  columns={[
                    {
                      title: '姓名',
                      key: 'name',
                      render: record => {
                        if (record.selectType == 0) {
                          return (
                            <span className="meeting-inner-attend">
                              {record.userName}
                            </span>
                          );
                        } else {
                          return (
                            <span className="meeting-outer-attend">
                              {record.userName}
                            </span>
                          );
                        }
                      }
                    },
                    {
                      title: '部门',
                      key: 'dept',
                      render: record => {
                        if (record.selectType == 0) {
                          return (
                            <span className="meeting-inner-attend">
                              {record.dept}
                            </span>
                          );
                        } else {
                          return (
                            <span className="meeting-outer-attend">
                              {record.dept}
                            </span>
                          );
                        }
                      }
                    },
                    {
                      title: '职位',
                      key: 'position',
                      render: record => {
                        if (record.selectType == 0) {
                          return (
                            <span className="meeting-inner-attend">
                              {record.position}
                            </span>
                          );
                        } else {
                          return (
                            <span className="meeting-outer-attend">
                              {record.position}
                            </span>
                          );
                        }
                      }
                    },
                    {
                      title: '操作',
                      key: 'operate',
                      render: record => {
                        return (
                          <span
                            style={{ paddingLeft: '15px' }}
                            onClick={() => {
                              let newUserList = this.state.userList.filter(
                                u => {
                                  return u.userId != record.userId;
                                }
                              );
                              this.setState({ userList: newUserList });
                            }}
                          >
                            <IconTip title="删除" type="shanchu" />
                          </span>
                        );
                      }
                    }
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  };

  render() {
    const { dispatch, meetingVideos } = this.props;
    const { list = [], total, pageNo, pageSize } = meetingVideos;
    const columns = [
      {
        title: '会议时间',
        key: 'time',
        width: '13%',
        render: record => {
          const meeting = record.meeting;
          return (
            <div>
              {/*<span>{meeting.showStartDate}</span>&nbsp;&nbsp;&nbsp;*/}
              {/*<span>{meeting.showStartTime.substring(meeting.showStartTime.indexOf(" ")+1,meeting.showStartTime.length)}</span>*/}
              <span>{meeting.showStartTime}</span>
              &nbsp;-&nbsp;
              <span>
                {meeting.showEndTime.substring(
                  meeting.showEndTime.indexOf(' ') + 1,
                  meeting.showEndTime.length
                )}
              </span>
            </div>
          );
        }
      },
      {
        title: '会议主题',
        width: '15%',
        key: 'title',
        render: record => {
          let cycleIcon = null;
          if (record.meeting.type != 0) {
            //循环会议
            cycleIcon = <Icon style={{ marginLeft: '10px' }} type="retweet" />;
          }
          return (
            <span>
              {record.meeting.name}
              {cycleIcon}
            </span>
          );
        }
      },
      {
        title: '会议室',
        key: 'room',
        width: '15%',
        render: record => {
          return <span>{record.meeting.roomNames}</span>;
        }
      },
      {
        title: '对接人',
        width: '8%',
        key: 'contactUser',
        render: record => {
          return <span>{record.contactUser}</span>;
        }
      },
      {
        title: '申请类型',
        key: 'applyType',
        render: record => {
          const { applyType } = record;
          if (applyType == '1') {
            return <span>直播</span>;
          } else if (applyType == '2') {
            return <span>录播</span>;
          } else if (applyType == '1,2') {
            return <span>直播，录播</span>;
          }

          return <span>{record.applyType}</span>;
        }
      },
      {
        title: '申请要求',
        key: 'requirement',
        width: '8%',
        render: record => {
          if (!record.requirement) {
            return null;
          }
          return (
            <span style={{ paddingLeft: '17px' }}>
              <Tooltip
                placement="top"
                title={record.requirement}
              >
                <Icon style={{ color: '#1B86E3' }} type="question-circle-o" />
              </Tooltip>
            </span>
          );
        }
      },
      {
        title: '申请状态',
        key: 'applyState',
        render: record => {
          const { state } = record;
          if (state == 0) {
            return (
              <div>
                <div className="point" style={{ backgroundColor: 'red' }} />
                新申请
              </div>
            );
          } else if (state == 1) {
            return (
              <div>
                <div className="point" style={{ backgroundColor: '#7BCC52' }} />
                处理中
              </div>
            );
          } else if (state == 2) {
            return (
              <span>
                <div className="point" style={{ backgroundColor: '#999999' }} />
                已完成
              </span>
            );
          } else if (state == -1) {
            return (
              <div>
                <div className="point" style={{ backgroundColor: 'red' }} />
                -1
              </div>
            );
          }
        }
      },
      {
        title: '操作',
        key: 'operate',
        render: record => {
          const { state, applyType, livePubState, recordPubState } = record;
          let btnList = [];
          let cancelLive = (
            <OperateSpan>
              <IconTip
                cls={'cancel-icon'}
                title="取消直播"
                type="quxiaozhibo"
              />
            </OperateSpan>
          );
          let pubLive = (
            <OperateSpan>
              <IconTip title="发布直播" type="zhibo1" />
            </OperateSpan>
          );
          let cancelRecord = (
            <OperateSpan>
              <IconTip cls={'cancel-icon'} title="取消录播" type="quxiaolubo" />
            </OperateSpan>
          );
          let pubRecord = (
            <OperateSpan>
              <IconTip title="发布录播" type="shipin" />
            </OperateSpan>
          );
          let edit = (
            <OperateSpan>
              <IconTip title="修改" type="75bianji" />
            </OperateSpan>
          );

          //修改按钮
          btnList.push(
            <span
              style={{ marginRight: '10px', cursor: 'pointer' }}
              onClick={() => {
                this.showEditModal(record);
              }}
            >
              {edit}
            </span>
          );
          if (state == 0 || state == 1) {
            if (applyType == '1') {
              if (livePubState == 1) {
                btnList.push(
                  <span
                    style={{ marginRight: '10px', cursor: 'pointer' }}
                    onClick={() => {
                      this.cancelLivingVideo(record);
                    }}
                  >
                    {cancelLive}
                  </span>
                );
              } else {
                btnList.push(
                  <span
                    style={{ marginRight: '10px', cursor: 'pointer' }}
                    onClick={() => {
                      this.showLivingModal(record);
                    }}
                  >
                    {pubLive}
                  </span>
                );
              }
            } else if (applyType == '2') {
              if (recordPubState == 1) {
                btnList.push(
                  <span
                    style={{ marginRight: '10px', cursor: 'pointer' }}
                    onClick={() => {
                      this.cancelRecordVideo(record);
                    }}
                  >
                    {cancelRecord}
                  </span>
                );
              } else {
                btnList.push(
                  <span
                    style={{ marginRight: '10px', cursor: 'pointer' }}
                    onClick={() => {
                      this.showRecordingModal(record);
                    }}
                  >
                    {pubRecord}
                  </span>
                );
              }
            } else if (applyType == '1,2') {
              if (livePubState == 1) {
                btnList.push(
                  <span
                    style={{ marginRight: '10px', cursor: 'pointer' }}
                    onClick={() => {
                      this.cancelLivingVideo(record);
                    }}
                  >
                    {cancelLive}
                  </span>
                );
              } else {
                btnList.push(
                  <span
                    style={{ marginRight: '10px', cursor: 'pointer' }}
                    onClick={() => {
                      this.showLivingModal(record);
                    }}
                  >
                    {pubLive}
                  </span>
                );
              }
              if (recordPubState == 1) {
                btnList.push(
                  <span
                    style={{ marginRight: '10px', cursor: 'pointer' }}
                    onClick={() => {
                      this.cancelRecordVideo(record);
                    }}
                  >
                    {cancelRecord}
                  </span>
                );
              } else {
                btnList.push(
                  <span
                    style={{ marginRight: '10px', cursor: 'pointer' }}
                    onClick={() => {
                      this.showRecordingModal(record);
                    }}
                  >
                    {pubRecord}
                  </span>
                );
              }
            }
          } else if (state == -1) {
            return <span>-1</span>;
          }
          return <div className="video-operate-icons">{btnList}</div>;
        }
      }
    ];

    return (
      <div className="log-manage">
        <div className="log-manage-down">
          <Table
            borderd
            columns={columns}
            dataSource={list}
            rowKey={record => record.id}
            pagination={{
              current: pageNo,
              pageSize,
              total,
              onChange: current => {
                dispatch({
                  type: 'account/getAllMeetingVideo',
                  payload: { current, pageSize }
                });
              }
            }}
          />
        </div>
        {this.createEditModal()}
        {this.createLivingModal()}
        {this.createRecordingModal()}
        {this.state.showUserSelect && (
          <Modal visible={true} width="800">
            <div className="meeting-user-select new_table video-meeting-user-select">
              <UserSelect
                intl={this.props.intl}
                dispatch={this.props.dispatch}
                modalType={VIDEO_PUBLIC_MODAL}
                selected={this.state.userList}
                holder={''}
                allDeptData={this.props.allDeptData}
                userByDept={this.props.userByDept}
                roomId={null}
                moreMeeting={this.state.moreMeeting}
                allRoomsList={this.props.allRoomsList}
                openModal={value => this.setState({ showUserSelect: value })}
                changePublicUser={value => {
                  this.setState({ userList: value });
                }}
                maskClosable={false}
                userInfo={this.props.userInfo}
              />
            </div>
          </Modal>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    account: { meetingVideos, allDeptData }
  } = state;
  const {
    meeting: { userByDept }
  } = state;
  return { meetingVideos, userByDept, allDeptData };
};

export default connect(mapStateToProps)(injectIntl(VideoManage));



// WEBPACK FOOTER //
// ./src/routes/SystemConfig/VideoManage.js